import React, { useState } from "react";
import { Workflow, X } from "lucide-react";

export const Diagram = ({ view = "diagram", image = "/diagram.png"}) => {
  const [open, setOpen] = useState(false);

  return (
    <section id="diagram" className="relative w-full py-16 px-4 md:px-8">
      <div className="mx-auto max-w-7xl rounded-3xl border border-white/10 bg-gradient-to-b from-slate-900/80 to-black/90 p-10 shadow-[0_20px_80px_rgba(0,0,0,0.6)] relative overflow-hidden backdrop-blur-md">
        {/* Encabezado */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <Workflow className="w-8 h-8 text-hitch animate-pulse" />
          <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight text-center">
            <span className="text-white">FLUJO DE </span>
            <span className="text-hitch">TRABAJO</span>
          </h2>
        </div>

        {/* Contenedor del diagrama */}
        <div className="relative rounded-2xl border border-white/10 bg-gradient-to-tr from-black/60 to-slate-900/60 p-6 md:p-10 shadow-inner">
          <div className="flex items-center justify-center">
            <img
             src={image}
              className="object-contain max-h-[500px] w-full rounded-xl shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer"
              alt="Diagrama"
              onClick={() => setOpen(true)}
            />
          </div>
        </div>
      </div>

      {/* Modal fullscreen */}
      {open && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center">
          <button
            onClick={() => setOpen(false)}
            className="absolute top-4 right-4 text-white p-2 rounded-full bg-black/50 hover:bg-black/70 transition"
          >
            <X className="w-7 h-7" />
          </button>
          <img
            src={image}
            alt="Diagrama fullscreen"
            className="w-full h-full object-contain"
          />
        </div>
      )}
    </section>
  );
};
